import app from "flarum/forum/app";
import Notification from "flarum/forum/components/Notification";
import { record, t } from "../../common/api";
export default class FactDeletedNotification extends Notification {
  icon() {
    return "fas fa-trash";
  }
  href() {
    return app.route("xgayFactManage");
  }
  content() {
    return t("deleted_notification");
  }
  excerpt() {
    const content = this.attrs.notification.content();
    return record(content) && typeof content.factId === "number" ? "Story #" + content.factId : "";
  }
}
flarum.reg.add('xgay-fact', 'forum/components/FactDeletedNotification', FactDeletedNotification);